import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ProductDetail } from 'api'
import { DataGrid, GridId } from 'view/components/datagrid'
import { productDetailsSelector } from 'selectors/productSelectors'
import { ProductColumnDefs, productGridOptions } from './ProductGridModel'

interface ProductGridProps {
  productList: ProductDetail[]
}

const mapStateToProps = createStructuredSelector({
  productList: productDetailsSelector
})

export const ProductGridComponent: React.FunctionComponent<ProductGridProps> = ({ productList }) => (
  <DataGrid
    gridId={GridId.AdminProductGrid}
    gridOptions={productGridOptions}
    disableGrouping={true}
    rowData={productList}
    columnDefs={ProductColumnDefs}
  />
)

export const ProductGrid = connect(mapStateToProps)(ProductGridComponent)
